export default "<ng-template [cdkPortalOutlet]=\"dynamicMenuPortal\"></ng-template>\r\n"